import { useMemo, useState } from "react"
import { Check, Copy, Fingerprint } from "lucide-react"
import { buildStorefrontUrl } from "../../utils/storefront"

type StorefrontStoreIdCardProps = {
  store: any
}

export default function StorefrontStoreIdCard({ store }: StorefrontStoreIdCardProps) {
  const storeId = String(store?._id || store?.id || "")
  const [copied, setCopied] = useState(false)

  const storefrontUrl = useMemo(() => buildStorefrontUrl(store), [store])

  const handleCopy = async () => {
    if (!storeId) return

    try {
      await navigator.clipboard.writeText(storeId)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = storeId
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    setCopied(true)
    window.setTimeout(() => setCopied(false), 2000)
  }

  if (!storeId) return null

  return (
    <div className="rounded-2xl border border-indigo-100 bg-indigo-50/70 p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-indigo-600 shadow-sm">
          <Fingerprint size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-900">Identifiant de ma boutique</p>
          <p className="mt-1 text-xs leading-5 text-slate-600">
            Copiez cet identifiant et envoyez-le au developpeur de votre site web. C'est grace a lui que votre site se connecte a cette boutique Gestock.
          </p>
        </div>
      </div>

      <div className="mt-4 rounded-xl border border-white/70 bg-white/90 px-3 py-3">
        <div className="flex items-center gap-3">
          <code className="min-w-0 flex-1 break-all font-mono text-sm font-semibold text-slate-800">
            {storeId}
          </code>
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-2 text-xs font-semibold text-white transition hover:bg-indigo-700"
          >
            {copied ? <Check size={14} /> : <Copy size={14} />}
            {copied ? "Copie !" : "Copier"}
          </button>
        </div>
        <p className="mt-2 text-[11px] leading-4 text-slate-500">
          Ne partagez pas ce lien public: seul l'identifiant est necessaire pour connecter votre site.
        </p>
      </div>

      {storefrontUrl ? (
        <div className="mt-3 rounded-xl border border-white/70 bg-white/80 px-3 py-2.5">
          <p className="text-[11px] uppercase tracking-[0.14em] text-slate-400">Votre page publique</p>
          <p className="mt-1 break-all text-xs font-medium text-slate-700">{storefrontUrl}</p>
        </div>
      ) : null}
    </div>
  )
}